<template>
  <div class="page_body">
      <div class="data_main">
          <el-tabs v-model="listQuery.deliveryType" @tab-click="changeTab" class="pr0">
              <el-tab-pane label="京东仓配送" name="2" v-if="power[0].length > 0"></el-tab-pane>
              <el-tab-pane label="自有仓配送" name="1" v-if="power[1].length > 0"></el-tab-pane>
          </el-tabs>
          <div class="data_search mt24" v-if="(listQuery.deliveryType == 2 && power[0].indexOf('1')>=0) || (listQuery.deliveryType == 1 && power[1].indexOf('1')>=0)">
              <el-form ref="listQuery" :inline="true" :model="listQuery" size="small" label-width="72px">
                  <el-form-item label="水卡编号：" prop="cardNo">
                      <el-input v-model="listQuery.cardNo" placeholder="请输入水卡编号" @keyup.enter.native="toSearchList"></el-input>
                  </el-form-item>
                  <el-form-item label="商品分类：" prop="cardId">
                      <el-select v-model="listQuery.cardId" @change="toSearchList">
                          <el-option label="全部水卡" value=""></el-option>
                          <el-option v-for="(item,index) in option" :key="index" :label="item.titleName" :value="item.id"></el-option>
                      </el-select>
                  </el-form-item>
                  <el-form-item label="使用期限：" prop="dateData2">
                    <el-date-picker
                            @change="toSearchList"
                            style="width: 100%"
                            v-model="dateData2"
                            type="daterange"
                            range-separator="~"
                            value-format="yyyy-MM-dd"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="下单时间：" prop="dateData2">
                    <el-date-picker
                            @change="toSearchList"
                            style="width: 100%"
                            v-model="dateData"
                            type="daterange"
                            range-separator="~"
                            value-format="yyyy-MM-dd"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="水卡状态：" prop="state">
                      <el-select v-model="listQuery.state" @change="toSearchList">
                          <el-option label="全部" value=""></el-option>
                          <el-option label="未启用" :value="0"></el-option>
                          <el-option label="未使用" :value="1"></el-option>
                          <el-option label="已发货" :value="2"></el-option>
                          <el-option label="配送中" :value="3"></el-option>
                          <el-option label="已完成" :value="4"></el-option>
                          <el-option label="理赔中" :value="11"></el-option>
                          <el-option label="理赔成功" :value="12"></el-option>
                          <el-option label="理赔驳回" :value="13"></el-option>
                          <el-option label="理赔完成" :value="14"></el-option>
                          <el-option label="已过期" :value="9"></el-option>
                          <el-option label="未激活" :value="15"></el-option>
                      </el-select>
                  </el-form-item>
                  <el-form-item label="采购单位：" prop="companyName">
                      <el-input v-model="listQuery.companyName" placeholder="请输入采购单位" @keyup.enter.native="toSearchList"></el-input>
                  </el-form-item>
                  <el-form-item label="销售类型：" prop="sellType">
                      <el-input v-model="listQuery.sellType" placeholder="请输入销售类型" @keyup.enter.native="toSearchList"></el-input>
                  </el-form-item>

                  <el-form-item class="last">
                      <el-button type="primary" :loading="isSearchLoading" @click="toSearchList()">查 询</el-button>
                      <el-button @click="resetSearch">重 置</el-button>
                  </el-form-item>
              </el-form>
          </div>

          <div class="data_group mt18">
              <!-- <el-button type="primary" size="small" icon="el-icon-plus" @click="openAdd">新增水卡</el-button> -->
              <el-button type="primary" size="small" icon="el-icon-plus" @click="openAddMore" v-if="(listQuery.deliveryType == 2 && power[0].indexOf('2')>=0) || (listQuery.deliveryType == 1 && power[1].indexOf('2')>=0)">批量新增</el-button>
              <el-button type="primary" size="small" @click="openAddMoreOther" v-if="(listQuery.deliveryType == 2 && power[0].indexOf('3')>=0) || (listQuery.deliveryType == 1 && power[1].indexOf('3')>=0)">批量激活</el-button>
              <!-- <el-button type="primary" size="small" @click="triggerFileUpload">导入水卡</el-button> -->
              <el-button type="primary" size="small" @click="getExport" v-if="(listQuery.deliveryType == 2 && power[0].indexOf('4')>=0) || (listQuery.deliveryType == 1 && power[1].indexOf('4')>=0)">批量导出</el-button>
              <!-- <el-button type="primary" size="small" @click="getTemplate">导出模板</el-button> -->
              <el-button type="primary" size="small" @click="postConfirm" v-if="listQuery.deliveryType == 1 && power[1].indexOf('11')>=0" :disabled="selectedOpenItems.length==0">确认送达</el-button>
              <!-- <input type="file" ref="fileInput" @change="handleFileUpload" style="display: none;"> -->
          </div>

          <div class="data_table mt18">
              <el-table ref="listTable" :data="listData" style="width: 100%" v-loading="isRequestLoading" @select="select" v-show="listQuery.deliveryType == 1">
                  <el-table-column width="70px" type="selection" align="center" :selectable="checkSelectable" v-if="power[1].indexOf('11')>=0"></el-table-column>
                  <el-table-column prop="cardNo" label="水卡编号" min-width="100" align="center"></el-table-column>
                  <el-table-column prop="spec" label="水卡规格" min-width="160px" align="center">
                  </el-table-column>
                  <el-table-column label="使用期限" min-width="160px" align="center">
                    <template slot-scope="scope">
                      <span>{{scope.row.beginDate}}</span><span v-if="scope.row.beginDate && scope.row.endDate"> ~ </span><span>{{scope.row.endDate}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="companyName" label="采购单位" min-width="100px" align="center">
                  </el-table-column>
                  <el-table-column prop="sellType" label="销售类型" min-width="100px" align="center" v-if="power[1].indexOf('9')>=0">
                  </el-table-column>
                  <el-table-column prop="price" label="价格" min-width="100px" align="center" v-if="power[1].indexOf('10')>=0">
                    <template slot-scope="scope">
                      <span>{{scope.row.price?scope.row.price:0}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="packUnit" label="发货数量" min-width="100px" align="center">
                    <template slot-scope="scope">
                      <span>{{scope.row.packUnit?scope.row.packUnit:0}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="下单时间" min-width="140px" align="center">
                    <template slot-scope="scope">
                      <span>{{scope.row.deliveryTime | times}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="password" label="水卡密码" min-width="120" align="center" v-if="power[1].indexOf('7')>=0">
                    <!-- <template slot-scope="scope">
                      <el-button type="text" @click="setPassword(scope.row.id)">修改</el-button>
                    </template> -->
                  </el-table-column>
                  <el-table-column prop="state" label="状态" min-width="100px" align="center">
                    <template slot-scope="scope">
                      <span v-if="scope.row.state == 0">未启用</span>
                      <span v-if="scope.row.state == 1">未使用</span>
                      <span v-if="scope.row.state == 2">已发货</span>
                      <span v-if="scope.row.state == 3">配送中</span>
                      <span v-if="scope.row.state == 4">已完成</span>
                      <span v-if="scope.row.state == 11">理赔中</span>
                      <span v-if="scope.row.state == 12">理赔成功</span>
                      <span v-if="scope.row.state == 13">理赔驳回</span>
                      <span v-if="scope.row.state == 14">理赔完成</span>
                      <span v-if="scope.row.state == 9">已过期</span>
                      <span v-if="scope.row.state == 15">未激活</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" min-width="80">
                    <template slot-scope="scope" v-if="selectedOpenItems.length==0">
                      <el-button type="text" @click="setDelay(scope.row.id)" v-if="scope.row.state == 9">延期</el-button>
                      <el-button type="text" @click="postConfirmOne(scope.row.id)" v-if="(scope.row.state == 2 || scope.row.state == 3) && power[1].indexOf('11')>=0">确认</el-button>
                      <el-button type="text" @click="delData(scope.row.id)" v-if="scope.row.state == 0 && power[1].indexOf('8')>=0">删除</el-button>
                    </template>
                  </el-table-column>
              </el-table>
              <el-table ref="listTables" :data="listData" style="width: 100%" v-loading="isRequestLoading"  v-show="listQuery.deliveryType == 2">
                  <el-table-column width="70px"  align="center" v-if="power[1].indexOf('11')>=0"></el-table-column>
                  <el-table-column prop="cardNo" label="水卡编号" min-width="100" align="center"></el-table-column>
                  <el-table-column prop="spec" label="水卡规格" min-width="160px" align="center">
                  </el-table-column>
                  <el-table-column label="使用期限" min-width="160px" align="center">
                    <template slot-scope="scope">
                      <span>{{scope.row.beginDate}}</span><span v-if="scope.row.beginDate && scope.row.endDate"> ~ </span><span>{{scope.row.endDate}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="companyName" label="采购单位" min-width="100px" align="center">
                  </el-table-column>
                  <el-table-column prop="sellType" label="销售类型" min-width="100px" align="center" v-if="power[0].indexOf('9')>=0">
                  </el-table-column>
                  <el-table-column prop="price" label="价格" min-width="100px" align="center" v-if="power[0].indexOf('10')>=0">
                    <template slot-scope="scope">
                      <span>{{scope.row.price?scope.row.price:0}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="packUnit" label="发货数量" min-width="100px" align="center">
                    <template slot-scope="scope">
                      <span>{{scope.row.packUnit?scope.row.packUnit:0}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="下单时间" min-width="140px" align="center">
                    <template slot-scope="scope">
                      <span>{{scope.row.deliveryTime | times}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="password" label="水卡密码" min-width="120" align="center" v-if="power[0].indexOf('7')>=0">
                    <!-- <template slot-scope="scope">
                      <el-button type="text" @click="setPassword(scope.row.id)">修改</el-button>
                    </template> -->
                  </el-table-column>
                  <el-table-column prop="state" label="状态" min-width="100px" align="center">
                    <template slot-scope="scope">
                      <span v-if="scope.row.state == 0">未启用</span>
                      <span v-if="scope.row.state == 1">未使用</span>
                      <span v-if="scope.row.state == 2">已发货</span>
                      <span v-if="scope.row.state == 3">配送中</span>
                      <span v-if="scope.row.state == 4">已完成</span>
                      <span v-if="scope.row.state == 11">理赔中</span>
                      <span v-if="scope.row.state == 12">理赔成功</span>
                      <span v-if="scope.row.state == 13">理赔驳回</span>
                      <span v-if="scope.row.state == 14">理赔完成</span>
                      <span v-if="scope.row.state == 9">已过期</span>
                      <span v-if="scope.row.state == 15">未激活</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" min-width="80">
                    <template slot-scope="scope">
                      <el-button type="text" @click="setDelay(scope.row.id)" v-if="scope.row.state == 9">延期</el-button>
                      <el-button type="text" @click="getDetail(scope.row.id)" v-if="scope.row.state != 0 && scope.row.state != 9 && scope.row.state != 1 && scope.row.state != 15">查看物流</el-button>
                      <el-button type="text" @click="delData(scope.row.id)" v-if="scope.row.state == 0 && power[0].indexOf('8')>=0">删除</el-button>
                    </template>
                  </el-table-column>
              </el-table>
          </div>

          <el-dialog class="popup_dialog" title="延期" :visible.sync="delay" :close-on-click-modal="false" :show-close="false" :destroy-on-close="true" width="600px">
            <el-form ref="formDate" :model="formDate" :rules="rules" label-width="120px" size="small">
                <el-form-item label="输入延期时间：" prop="endDate">
                    <el-date-picker
                      v-model="formDate.endDate"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" :loading="isSubmitLoading" @click="postDelay('formDate')">提  交</el-button>
                    <el-button @click="delay=false">关  闭</el-button>
                </el-form-item>
            </el-form>
          </el-dialog>
          <el-dialog class="popup_dialog" title="修改当前密码" :visible.sync="password" :close-on-click-modal="false" :show-close="false" :destroy-on-close="true" width="600px">
            <el-form ref="formPwd" :model="formPwd" :rules="rulesPwd" label-width="120px" size="small">
                <el-form-item label="输入新密码：" prop="password">
                  <el-input v-model="formPwd.password" placeholder="请输入新密码" show-password></el-input>
                </el-form-item>
      
                <el-form-item label="确认密码：" prop="newPassWordAgain">
                  <el-input v-model="formPwd.newPassWordAgain" placeholder="请输入新密码" show-password></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :loading="isSubmitLoading" @click="postPwd('formPwd')">提  交</el-button>
                    <el-button @click="password=false">关  闭</el-button>
                </el-form-item>
            </el-form>
          </el-dialog>
          <el-dialog class="popup_dialog" title="查看配送信息" :visible.sync="logisticsInfo" :close-on-click-modal="false" :show-close="false" :destroy-on-close="true" width="1000px">
            <div class="file-list" style="line-height: 25px;">
              <div>用户姓名：{{logistics.name}}</div>
              <div>用户地址：{{logistics.province+' '+logistics.city+' '+logistics.address}}</div>
              <!-- <div>配送仓库：{{logistics.logisticsCode}}</div> -->
              <div v-if="logistics.logisticsInfo && logistics.logisticsInfo.length>0">配送单号：{{logistics.logisticsInfo[0].waybillNo}}</div>
              <div>备注：{{logistics.remark?logistics.remark:'-'}}</div>
            </div>
            <div class="data_table log_table mt18" v-if="logistics.logisticsInfo && logistics.logisticsInfo.length>0">
              <el-table :data="logistics.logisticsInfo" style="width: 100%;padding:0"  height="400px">
                <el-table-column prop="operateTitle" label="进程"></el-table-column>
                <el-table-column prop="operateName" label="操作人"></el-table-column>
                <el-table-column prop="operateTime" label="时间"></el-table-column>
                <el-table-column prop="operateRemark" label="具体操作"></el-table-column>
              </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button @click="logisticsInfo=false">关 闭</el-button>
            </div>
          </el-dialog>
          <el-dialog class="popup_dialog" title="新增水卡" :visible.sync="addCard" :close-on-click-modal="false" :show-close="false" :destroy-on-close="true" width="600px">
            <el-form ref="formData" :model="formData" :rules="rulesData" label-width="80px" size="small">
                <el-form-item label="卡号：" prop="cardNo">
                    <el-input v-model="formData.cardNo" placeholder="请输入9位数卡号"></el-input>
                </el-form-item>
                <el-form-item label="密码：" prop="password">
                    <el-input v-model="formData.password" placeholder="请输入8位数密码"></el-input>
                </el-form-item>
                <el-form-item label="采购单位：" prop="companyName">
                    <el-input v-model="formData.companyName" placeholder="请输入采购单位"></el-input>
                </el-form-item>
                <el-form-item label="销售类型：" prop="sellType">
                    <el-input v-model="formData.sellType" placeholder="请输入销售类型"></el-input>
                </el-form-item>
                <el-form-item label="使用期限：" prop="dateData2">
                  <el-date-picker
                          style="width: 100%"
                          v-model="formData.dateData2"
                          type="daterange"
                          range-separator="~"
                          value-format="yyyy-MM-dd"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
                <!-- <el-form-item label="使用区域：" prop="deliveryArea">
                  <el-select v-model="formData.deliveryArea" multiple placeholder="请选择">
                    <el-option
                      v-for="item in proList"
                      :key="item.name"
                      :label="item.name"
                      :value="item.name">
                    </el-option>
                  </el-select>
                </el-form-item> -->
                <el-form-item label="水卡价格：">
                    <el-input v-model="formData.price" placeholder="请输入水卡价格"></el-input>
                </el-form-item>
                <el-form-item label="所属规格：" prop="cardId">
                  <el-select v-model="formData.cardId">
                      <el-option v-for="(item,index) in option" :key="index" :label="item.titleName" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" :loading="isSubmitLoading" @click="submitFormAdd('formData')">提  交</el-button>
                    <el-button @click="closeAdd">关  闭</el-button>
                </el-form-item>
            </el-form>
          </el-dialog>
          <el-dialog class="popup_dialog" title="批量新增" :visible.sync="addCardMore" :close-on-click-modal="false" :show-close="false" :destroy-on-close="true" width="600px">
            <el-form ref="formDataMore" :model="formDataMore" :rules="rulesDataMore" label-width="80px" size="small">
                <el-form-item label="生成数量：" prop="num">
                    <el-input v-model.number="formDataMore.num" placeholder="请输入生成数量"></el-input>
                </el-form-item>
                <el-form-item label="卡号：" prop="cardNo">
                    <el-input v-model="formDataMore.cardNo" placeholder="请输入首位卡号"></el-input>
                </el-form-item>
                <el-form-item label="">
                  <div>卡号会根据首位水卡编号，将个位数字进行递增</div>
                  <div>所有密码随机生成</div>
                </el-form-item>
                <!-- <el-form-item label="采购单位：" prop="companyName">
                    <el-input v-model="formDataMore.companyName" placeholder="请输入采购单位"></el-input>
                </el-form-item>
                <el-form-item label="销售类型：" prop="sellType">
                    <el-input v-model="formDataMore.sellType" placeholder="请输入销售类型"></el-input>
                </el-form-item>
                <el-form-item label="使用期限：" prop="dateData2">
                  <el-date-picker
                          style="width: 100%"
                          v-model="formDataMore.dateData2"
                          type="daterange"
                          range-separator="~"
                          value-format="yyyy-MM-dd"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="使用区域：" prop="deliveryArea">
                  <el-select v-model="formDataMore.deliveryArea" multiple placeholder="请选择">
                    <el-option
                      v-for="item in proList"
                      :key="item.name"
                      :label="item.name"
                      :value="item.name">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="水卡价格：">
                    <el-input v-model="formDataMore.price" placeholder="请输入水卡价格"></el-input>
                </el-form-item> -->
                <el-form-item label="所属规格：" prop="cardId">
                  <el-select v-model="formDataMore.cardId">
                      <el-option v-for="(item,index) in option" :key="index" :label="item.titleName" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" :loading="isSubmitLoading" @click="submitFormAddMore('formDataMore')">提  交</el-button>
                    <el-button @click="addCardMore=false">关  闭</el-button>
                </el-form-item>
            </el-form>
          </el-dialog>
          <el-dialog class="popup_dialog" title="批量激活" :visible.sync="activationCardMore" :close-on-click-modal="false" :show-close="false" :destroy-on-close="true" width="600px">
            <el-form ref="formDataMoreOther" :model="formDataMoreOther" :rules="rulesDataMoreOther" label-width="80px" size="small">
                <el-form-item label="卡号区间：" prop="cardNo">
                    <el-input v-model="formDataMoreOther.cardNo" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="~" prop="cardNo1" class="andNumber">
                    <el-input v-model="formDataMoreOther.cardNo1" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="使用期限：" prop="dateData2">
                  <el-date-picker
                          style="width: 100%"
                          v-model="formDataMoreOther.dateData2"
                          type="daterange"
                          range-separator="~"
                          value-format="yyyy-MM-dd"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="采购单位：" prop="companyName">
                    <el-input v-model="formDataMoreOther.companyName" placeholder="请输入采购单位"></el-input>
                </el-form-item>
                <el-form-item label="销售类型：" prop="sellType">
                    <el-input v-model="formDataMoreOther.sellType" placeholder="请输入销售类型"></el-input>
                </el-form-item>
                <!-- <el-form-item label="使用区域：" prop="deliveryArea">
                  <el-select v-model="formDataMoreOther.deliveryArea" multiple placeholder="请选择">
                    <el-option
                      v-for="item in proList"
                      :key="item.name"
                      :label="item.name"
                      :value="item.name">
                    </el-option>
                  </el-select>
                </el-form-item> -->
                <el-form-item label="水卡价格：" prop="price">
                    <el-input v-model="formDataMoreOther.price" placeholder="请输入水卡价格"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" :loading="isSubmitLoading" @click="submitFormAddMoreOther('formDataMoreOther')">提  交</el-button>
                    <el-button @click="activationCardMore=false">关  闭</el-button>
                </el-form-item>
            </el-form>
          </el-dialog>
          <el-dialog class="popup_dialog" title="批量导出" :visible.sync="exportDialog" :close-on-click-modal="false" :show-close="false" :destroy-on-close="true" width="600px">
            <el-form ref="exportFrom" :model="exportFrom" label-width="80px" size="small">
                <!-- <el-form-item label="卡号：" prop="cardNo">
                    <el-input v-model="exportFrom.cardNo" placeholder="请输入卡号"></el-input>
                </el-form-item> -->
                <el-form-item label="使用区域：" prop="deliveryArea">
                  <el-select v-model="exportFrom.deliveryArea" placeholder="请选择">
                    <el-option
                      v-for="item in proList"
                      :key="item.name"
                      :label="item.name"
                      :value="item.name">
                    </el-option>
                  </el-select>
                </el-form-item>
                <!-- <el-form-item label="水卡范围：" v-if="formData.deliveryArea.length>0">
                  <div style="width:100%;display:flex" v-for="(item,index) in formData.deliveryArea" :key="index">
                    <div style="width:50%;text-align:center">{{item}}</div>
                    <el-button type="text" @click="delAreas(ndex)">删除</el-button>
                  </div>
                </el-form-item> -->
                <el-form-item label="所属规格：" prop="cardId">
                  <el-select v-model="exportFrom.cardId" @change="change1">
                      <el-option v-for="(item,index) in option" :key="index" :label="item.titleName" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="配送方式：" prop="deliveryType">
                  <el-select v-model="exportFrom.deliveryType" @change="change2">
                      <el-option label="自有仓配送" value="1"></el-option>
                      <el-option label="京东仓配送" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="状态：" prop="state">
                  <el-select v-model="exportFrom.state">
                      <el-option label="未激活" :value="15"></el-option>
                      <el-option label="未启用" :value="0"></el-option>
                      <el-option label="未使用" :value="1"></el-option>
                      <el-option label="已申请" :value="2"></el-option>
                      <el-option label="已发货" :value="3"></el-option>
                      <el-option label="已完成" :value="4"></el-option>
                      <el-option label="理赔中" :value="11"></el-option>
                      <el-option label="理赔成功" :value="12"></el-option>
                      <el-option label="理赔驳回" :value="13"></el-option>
                      <el-option label="理赔完成" :value="14"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" :loading="isSubmitLoading" @click="getExport">提  交</el-button>
                    <el-button @click="exportDialog=false">关  闭</el-button>
                </el-form-item>
            </el-form>
          </el-dialog>

          <pagination :size="listQuery.pageSize" :total="pages.total" :current="listQuery.page" :pages="pages.pages" @pageChange="pageChange"/>
      </div>
  </div>
</template>

<script>
import axios from 'axios'
import pagination from '@/components/pagination'
import {getOrderDetail,getCardList,postPwd,postDelay,postorderDel,postOrder,getTemplate,postTemplate,getPro,getSelf,getDelivery,postConfirm,postCardBatch,getExport,postCardUpBatch} from '@/api'
import {mapState} from "vuex";
export default {
name: "contentArticleIndex",
data () {
  var validatePass2 = (rule, value, callback) => {
    if (value === '') {
      callback(new Error('请再次输入密码'));
    } else if (value !== this.formPwd.password) {
      callback(new Error('两次输入密码不一致!'));
    } else {
      callback();
    }
  };  
  return {
    logisticsInfo:false,
    logistics:{},
    dateData:[],
    dateData2:[],
    listQuery: {
      state:'',
      beginDate:'',
      endDate:'',
      companyName:'',
      sellType:'',
      cardNo: '',
      deliveryType: '2',
      cardId: '',
      selfFlag:false,
      page: 1,
      pageSize: 10
    },
    pages: {
      total: 0,
      pages: 0
    },
    option:[],
    isSubmitLoading:false,
    isSearchLoading: false,
    isRequestLoading: false,
    listData: [],
    formDate:{
      id:'',
      endDate:''
    },
    delay:false,
    formPwd:{
      id:'',
      password:'',
      newPassWordAgain:'',
    },
    password:false,
    rulesPwd: {
      password: [
        { required: true, message: '请输入密码', trigger: 'blur' },
      ],
      newPassWordAgain: [
        { validator: validatePass2, trigger: 'blur' }
      ]
    },
    rules: {
      endDate: [
        { required: true, message: '请选择日期', trigger: 'change' },
      ],
    },
    proList:[],
    addCard:false,
    allowedFileTypes: ['xls','xlsx'],
    rulesData:{
      cardNo: [
        {required: true, message: '请输入9位数卡号', trigger: 'blur'}
      ],
      password: [
        {required: true, message: '请输入8位数密码', trigger: 'blur'}
      ],
      companyName: [
        {required: true, message: '请输入采购单位', trigger: 'blur'}
      ],
      sellType: [
        {required: true, message: '请输入销售类型', trigger: 'blur'}
      ],
      // deliveryArea: [
      //   {required: true, message: '请添加使用区域', trigger: 'blur'}
      // ],
      price: [
        {required: true, message: '请输入价格', trigger: 'blur'}
      ],
      dateData2:[
        {required: true, message: '请选择使用期限', trigger: 'change'}
      ],
      cardId:[
        {required: true, message: '请选择所属规格', trigger: 'change'}
      ],
    },
    formData:{
      cardNo:'',
      password:'',
      companyName:'',
      sellType:'',
      beginDate:'',
      endDate:'',
      price:'',
      cardId:'',
      dateData2:[],
    },
    selectedOpenItems:[],
    addCardMore:false,
    rulesDataMore:{
      num: [
        {required: true, message: '请输入生成数量', trigger: 'blur'}
      ],
      cardNo: [
        {required: true, message: '请输入首位卡号', trigger: 'blur'}
      ],
      cardId:[
        {required: true, message: '请选择所属规格', trigger: 'change'}
      ],
    },
    formDataMore:{
      num:0,
      cardNo:'',
      cardId:'',
    },
    exportDialog:false,
    exportFrom:{
      cardId:'',
      cardNo:'',
      deliveryType:'',
      deliveryArea:'',
      state:0,
    },
    activationCardMore:false,
    rulesDataMoreOther:{
      cardNo: [
        {required: true, message: '请输入卡号区间首位', trigger: 'blur'}
      ],
      cardNo1: [
        {required: true, message: '请输入卡号区间末尾', trigger: 'blur'}
      ],
      companyName: [
        {required: true, message: '请输入采购单位', trigger: 'blur'}
      ],
      sellType: [
        {required: true, message: '请输入销售类型', trigger: 'blur'}
      ],
      price: [
        {required: true, message: '请输入价格', trigger: 'blur'},
        // { pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输⼊正确的格式,可保留两位⼩数', trigger: 'blur' }
      ],
      dateData2:[
        {required: true, message: '请选择使用期限', trigger: 'change'}
      ]
    },
    formDataMoreOther:{
      num:'-1',
      cardNo:'',
      cardNo1:'',
      companyName:'',
      sellType:'',
      beginDate:'',
      endDate:'',
      price:'',
      dateData2:[],
    },
    power:null
  }
},
computed: {
  ...mapState({
    listKeepAlive: state => state.app.listKeepAlive,
  })
},
filters:{
  times(e){
    if (e) {
      return e
    } else {
      return '-'
    }
  }
},
activated () {
  this.getCardList()
},
created(){
  
  let rules = JSON.parse(localStorage.getItem('userRole')).page.sort()
  let newArray = this.$router.options.routes.filter(item => item.path !== '/');
  console.log(rules,newArray[0])
  if (!rules.includes('a')) this.$router.replace({'path':newArray[0].children[0].path})
  this.power = JSON.parse(localStorage.getItem('userRole')).power[0]
  if (this.power[0].length == 0) {
    this.listQuery.deliveryType = '1'
  }
  this.$nextTick(() => {
    if (this.power[1].indexOf('10')>=0) {
      document.querySelector('.el-table-column--selection').querySelector(".cell").innerHTML = '选择'
    }
  })
},
methods: {
  changeTab(){
    getCardList({data:{type:this.listQuery.deliveryType}}).then(res=>{
      this.option = res.data
      this.toSearchList()
    })
  },
  change1(e){
    if (e) {
      this.exportFrom.deliveryType = ''
    }
  },
  change2(e){
    if (e) {
      this.exportFrom.cardId = ''
    }
  },
  openExport(){
    this.exportFrom={
        cardId:'',
        cardNo:'',
        deliveryType:'',
        deliveryArea:'',
        state:0,
    }
    this.exportDialog = true
  },
  getExport(){
    // let form = {
    //     cardId:this.exportFrom.cardId,
    //     cardNo:this.exportFrom.cardNo,
    //     deliveryType:this.exportFrom.deliveryType,
    //     province:this.exportFrom.deliveryArea,
    //     state:this.exportFrom.state,
    // }
    let form = {pwdFlag:false,sellTypeFlag:false,priceFlag:false,...this.listQuery}
    if((this.listQuery.deliveryType == 2 && this.power[0].indexOf('7')>=0) || (this.listQuery.deliveryType == 1 && this.power[1].indexOf('7')>=0)){
      form.pwdFlag = true
    }
    if((this.listQuery.deliveryType == 2 && this.power[0].indexOf('9')>=0) || (this.listQuery.deliveryType == 1 && this.power[1].indexOf('9')>=0)){
      form.sellTypeFlag = true
    }
    if((this.listQuery.deliveryType == 2 && this.power[0].indexOf('10')>=0) || (this.listQuery.deliveryType == 1 && this.power[1].indexOf('10')>=0)){
      form.priceFlag = true
    }
    console.log(form)
    getExport(form).then(res=>{
      if (res) {
        this.$message.success('导出成功')
        this.exportDialog = false
      }
    })
  },
  checkSelectable (row) {
    if (row.state == 2 || row.state == 3) {
        return true
    } else {
        return false
    }
  },
  postConfirmOne(id){
    this.$confirm('是否确认送达?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        postConfirm({data:[id]}).then(res=>{
          if (res.code == 0) {
            this.toSearchList()
          }
        })
      }).catch(() => {});
  },
  postConfirm(){
    let arr = []
    this.selectedOpenItems.forEach(i=>{
      arr.push(i.id)
    })
    postConfirm({data:arr}).then(res=>{
      if (res.code == 0) {
        this.selectedOpenItems = []
        this.toSearchList()
      }
    })
  },
    //选中table已有数据
  selectedPreExisting (rows) {
    if (rows.length > 0) {
      //这里使用this.$nextTick是防止表格未渲染完成就执行，导致无法添加选中效果
      this.$nextTick(() => {
        rows.forEach(row => {
          //判断row是存在当前tableData
          let selectedItem = this.listData.find(item => item.id == row.id)
          this.$refs['listTable'].toggleRowSelection(selectedItem);
        });
      })
    } else {
      this.$refs['listTable'].clearSelection();
    }
  },
  //表格单选
  select (selection, row) {
    //因为翻页之后，点选时selection会出现undefined,所以这里需要进行判断
    //这里可以通过判断选择selection中有没有row，就可以判断出是增加还是删减
    if (selection && selection.find(item => item && (item.id == row.id))) {
      this.addRows([row])
    } else {
      this.deleteRows([row])
    }
  },
  //添加选中
  addRows (rows) {
    rows.forEach(row => {
      //过滤，当selectedItems有此条数据时，则直接返回，不执行添加
      if (this.selectedOpenItems.find(item => item.id == row.id)) { return }
      this.selectedOpenItems.push(row)
    });
  },
  //取消选中
  deleteRows (rows) {
    //当selectedItems为空数组时，不执行删除
    if (this.selectedOpenItems.length == 0) { return }
    rows.forEach(row => {
      this.selectedOpenItems.forEach((value,index)=>{
          if (value.id == row.id) {
            this.selectedOpenItems.splice(index,1)
          }
      });
    })
  },
  getPro(){
    getPro().then(res=>{
      this.proList = res.data
    })
  },
  openAddMore(){
    this.formDataMore={
      num:0,
      cardNo:'',
      cardId:'',
    },
    this.addCardMore=true
    this.$nextTick(()=>{
      this.$refs['formDataMore'].clearValidate()
    })
  },
  openAddMoreOther(){
    this.formDataMoreOther={
      num:'-1',
      cardNo:'',
      cardNo1:'',
      companyName:'',
      sellType:'',
      beginDate:'',
      endDate:'',
      price:'',
      dateData2:[],
    },
    this.activationCardMore=true
    this.$nextTick(()=>{
      this.$refs['formDataMoreOther'].clearValidate()
    })
  },
  openAdd(){
    this.formData.password = this.generateRandomPassword(8)
    this.addCard=true
  },
  generateRandomPassword(length) {
    const charset = "ABCDEFGHLJKMNPQRSTUVWXYZ23456789";
    let password = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      password += charset[randomIndex];
    }
    return password;
  },
  triggerFileUpload(){
    this.$refs.fileInput.click()
  },
  handleFileUpload(event) {
    const file = event.target.files[0]

    // 验证文件类型
    const fileType = file.name.split(".").pop().toLowerCase();
    if (!this.allowedFileTypes.includes(fileType)) {
      this.$message.error("错误: 不支持的文件类型。");
      return
    }

    // 验证文件大小
    // if (file.size > this.maxFileSize) {
    //   this.$message.error(`错误: 文件大小超过 ${this.maxFileSize / (1024 * 1024)}MB 限制。`);
    //   return
    // }

    const formData = new FormData()
    formData.append('file', file)

    // 测试用,项目中换成自己的上传接口
    
    axios({
      method: "POST",
      baseURL: window.config.baseURL,
      url: postTemplate(),
      timeout: 30000,
      headers: {
        'Content-Type': 'application/json',
        'card': localStorage.getItem('access_token'),
      },
      data: formData,
    })
      .then(response => {
        if (response.data.code == 0){
          this.$message.success("文件上传成功。");
          this.$refs['listQuery'].resetFields()
          this.toSearchList()
        } else {
          this.$message.error(response.data.message)
        }
          this.$refs.fileInput.value=''

      })
      .catch(() => {
          this.$refs.fileInput.value=''
        // this.$message.error("文件上传失败。");

        // console.error('文件上传失败:', error)
      })
  },
  // postTemplate(){},
  getTemplate(){
    getTemplate().then()
  },
  submitFormAddMoreOther (formName) {
    this.$refs[formName].validate(valid => {
      if (valid) {
        if (this.formDataMoreOther.cardNo>this.formDataMoreOther.cardNo1) {
          return this.$message.error('卡号区间请按从小到大输入')
        }
        this.isSubmitLoading = true
        this.formDataMoreOther.beginDate = this.formDataMoreOther.dateData2[0]
        this.formDataMoreOther.endDate = this.formDataMoreOther.dateData2[1]
        // let arr = [this.formData.deliveryArea]
        postCardUpBatch({
          data: this.formDataMoreOther
        }).then(res => {
          this.isSubmitLoading = false
          if (res.code === 0) {
            this.$message({
              message: '批量激活成功',
              type: 'success',
              showClose: true,
            });
            this.activationCardMore = false
            this.$refs['listQuery'].resetFields()
            this.toSearchList()
          }
        }).catch(() => {
          this.isSubmitLoading = false
        })
      }
    })
  },
  submitFormAddMore (formName) {
    this.$refs[formName].validate(valid => {
      if (valid) {
        this.isSubmitLoading = true
        // this.formDataMore.beginDate = this.formDataMore.dateData2[0]
        // this.formDataMore.endDate = this.formDataMore.dateData2[1]
        // let arr = [this.formData.deliveryArea]
        postCardBatch({
          data: this.formDataMore
        }).then(res => {
          this.isSubmitLoading = false
          if (res.code === 0) {
            this.$message({
              message: '批量新增成功',
              type: 'success',
              showClose: true,
            });
            this.addCardMore = false
            this.$refs['listQuery'].resetFields()
            this.toSearchList()
          }
        }).catch(() => {
          this.isSubmitLoading = false
        })
      }
    })
  },
  submitFormAdd (formName) {
    this.$refs[formName].validate(valid => {
      if (valid) {
        this.isSubmitLoading = true
        this.formData.beginDate = this.formData.dateData2[0]
        this.formData.endDate = this.formData.dateData2[1]
        // let arr = [this.formData.deliveryArea]
        postOrder({
          data: this.formData
        }).then(res => {
          this.isSubmitLoading = false
          if (res.code === 0) {
            this.$message({
              message: '水卡新增成功',
              type: 'success',
              showClose: true,
            });
            this.formData= {
              cardNo:'',
              password:'',
              beginDate:'',
              endDate:'',
              price:'',
              cardId:'',
              dateData2:[]
            },
            this.addCard = false
            this.$refs['listQuery'].resetFields()
            this.toSearchList()
          }
        }).catch(() => {
          this.isSubmitLoading = false
        })
      }
    })
  },
  closeAdd(){
    this.formData= {
      cardNo:'',
      password:'',
      beginDate:'',
      endDate:'',
      price:'',
      cardId:'',
      dateData2:[]
    },
    this.addCard = false
  },
  delData(id){
    this.$confirm('此操作将永久删除该水卡, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      closeOnClickModal: false,
      type: 'warning'
    }).then(() => {
      postorderDel({data:[id]}).then(res => {
        if (res.code === 0) {
          this.$message({
            message: '水卡删除成功',
            type: 'success',
            showClose: true,
          });
          this.getOrder()
        }
      })
    }).catch(() => {});
  },
  postPwd(formName){
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.isSubmitLoading = true
          postPwd({
            data: this.formPwd
          }).then(res => {
            this.isSubmitLoading = false
            if (res.code === 0) {
              this.$message({
                message: '修改密码成功',
                type: 'success',
                showClose: true,
              });
              this.password = false
              this.getOrder()
            }
          }).catch(() => {
            this.isSubmitLoading = false
          })
        }
      })
  },
  postDelay(formName){
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.isSubmitLoading = true
          postDelay({
            data: this.formDate
          }).then(res => {
            this.isSubmitLoading = false
            if (res.code === 0) {
              this.$message({
                message: '修改延期成功',
                type: 'success',
                showClose: true,
              });
              this.delay = false
              this.getOrder()
            }
          }).catch(() => {
            this.isSubmitLoading = false
          })
        }
      })
  },
  setPassword(id){
    this.formPwd = {
      id:id,
      password:'',
      newPassWordAgain:''
    }
    this.password=true
  },
  setDelay(id){
    this.formDate = {
      id:id,
      endDate:''
    }
    this.delay=true
  },
  pageChange (e) {
    this.listQuery.page = e.current
    this.listQuery.pageSize = e.size
    this.getOrder()
  },
  toSearchList () {
    this.listQuery.page = 1
    this.isSearchLoading = true
    this.getOrder()
  },
  getCardList(){
    getCardList({data:{type:this.listQuery.deliveryType}}).then(res=>{
      this.option = res.data
      this.getPro()
      this.getOrder()
    })
  },
  getDetail(id){
    getOrderDetail(id).then(res=>{
      this.logistics = res.data
      this.logisticsInfo = true
    })
  },
  resetSearch(){
    this.$refs['listQuery'].resetFields()
    this.dateData2 = []
    this.dateData = []
  },
  getOrder(){
    if (this.dateData2 && this.dateData2.length>0) {
      this.listQuery.beginDate = this.dateData2[0]
      this.listQuery.endDate = this.dateData2[1]+" 23:59:59"
    } else {
      this.listQuery.beginDate = ''
      this.listQuery.endDate = ''
    }
    if (this.dateData && this.dateData.length>0) {
      this.listQuery.deliveryTimeStart = this.dateData[0]
      this.listQuery.deliveryTimeEnd = this.dateData[1]+" 23:59:59"
    } else {
      this.listQuery.deliveryTimeStart = ''
      this.listQuery.deliveryTimeEnd = ''
    }
    this.listQuery.selfFlag = false
    if (this.listQuery.deliveryType == 1 && this.power[1].indexOf('6')>=0) {
      this.listQuery.selfFlag = true
    }
    if (this.listQuery.deliveryType == 2 && this.power[0].indexOf('6')>=0) {
      this.listQuery.selfFlag = true
    }
    let request = (this.listQuery.deliveryType == 1)?getSelf(this.listQuery):getDelivery(this.listQuery)
    request.then(res=>{
      this.isSearchLoading = false
      this.listData = res.data.records
      this.pages.total = res.data.total
      this.pages.pages = res.data.pages
      if (this.listQuery.deliveryType == 1) {
          this.selectedPreExisting(this.selectedOpenItems)
      }
    }).catch(()=>{
      // console.log(err)
        this.isSearchLoading = false
    })
  },
},
components: {
  pagination
}
}
</script>
<style lang="scss" scoped>
.andNumber{
  /deep/ .el-form-item__label{
    text-align: center !important;
    position: relative;
    &::before{
      position: absolute;
      left: 0;
    }
  }
}
</style>